import { render, staticRenderFns } from "./browseRecords.vue?vue&type=template&id=e0e44920&scoped=true"
import script from "./browseRecords.vue?vue&type=script&lang=js"
export * from "./browseRecords.vue?vue&type=script&lang=js"
import style0 from "./browseRecords.vue?vue&type=style&index=0&id=e0e44920&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e44920",
  null
  
)

export default component.exports